import { LitElement, html, css, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { colors } from '../styles/shared.js';
import { t, stageName, stageComment } from '../i18n.js';

@customElement('stage-info')
export class StageInfo extends LitElement {
  static styles = [
    colors,
    css`
      :host {
        pointer-events: none;
      }
      .top-right {
        position: absolute;
        top: env(safe-area-inset-top, 12px);
        right: env(safe-area-inset-right, 12px);
        text-align: right;
        padding: 8px;
      }
      .top-center {
        position: absolute;
        top: env(safe-area-inset-top, 12px);
        left: 0;
        right: 0;
        text-align: center;
        padding: 8px;
      }
      .title {
        color: var(--color-white);
        font-size: 1rem;
        font-family: var(--font-title);
      }
      .stage-name {
        color: #ffff00;
        font-size: 1rem;
        margin-top: 2px;
      }
      .comment-hint {
        position: absolute;
        bottom: env(safe-area-inset-bottom, 12px);
        left: var(--power-icons-right-edge, 40%);
        right: env(safe-area-inset-right, 12px);
        text-align: right;
        color: #ffff00;
        font-size: 0.95rem;
        padding: 8px 16px;
        pointer-events: none;
      }
    `,
  ];

  @property() accessor stageName = '';
  @property() accessor messageKey: string | null = null;
  @property({ type: Boolean }) accessor isTouch = false;
  @property({ type: Number }) accessor aspect = 1.33;

  render() {
    const displayName = this.messageKey
      ? t(this.messageKey)
      : stageName(this.stageName);

    if (this.isTouch) {
      return this._renderTouch(displayName);
    }
    return this._renderDesktop(displayName);
  }

  private _renderTouch(displayName: string) {
    if (this.aspect < 1.0) {
      // Portrait: title + stage name centered
      return html`
        <div class="top-center">
          <div class="title">${t('title-name')}</div>
          <div class="stage-name">${displayName}</div>
        </div>
      `;
    }
    // Landscape: just stage name right-aligned
    return html`
      <div class="top-right">
        <div class="stage-name">${displayName}</div>
      </div>
    `;
  }

  private _renderDesktop(displayName: string) {
    const comment = stageComment(this.stageName, false);
    return html`
      <div class="top-right">
        <div class="title">${t('title-name')}</div>
        <div class="stage-name">${displayName}</div>
      </div>
      ${comment
        ? html`<div class="comment-hint">${comment}</div>`
        : nothing}
    `;
  }
}
